<template lang="pug">
  .month-and-year-wrapper(v-if="reportKinds")
    div(v-if="reportKinds.length > 1")
      PRadio(v-model="kind" option="month" label="por mês")
      PRadio(v-model="kind" option="period" label="por período")

    div(v-if="kind === 'period'")
      PDatePicker(
        label="início período",
        name="startDate",
        v-model="startDate",
        format="DD/MM/YYYY",
        @change="updateState"
      )

      PDatePicker(
        label="fim período",
        name="endDate",
        v-model="endDate",
        format="DD/MM/YYYY",
        @change="updateState"
      )

    div(v-if="kind === 'month'")
      PSelect(v-model="month" title="mês" :options="monthsOptions" labelItem="name" @change="updateState" :allowEmpty="false")
      PSelect(v-model="year" title="ano" :options="yearsOptions" labelItem="id" @change="updateState" :allowEmpty="false")

</template>

<script>
import moment from 'moment'
import {range} from 'src/utils'
import { handlerUseStateVmodel } from 'src/common/mixins/handlerUseStateVmodel'

const monthsRespective = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
]

export default {
  name: 'MonthAndPeriodSelection',
  mixins: [handlerUseStateVmodel(false)],
  props: {
    reportKinds: {}
  },
  created () {
    this.updateState()
    if (this.reportKinds) {
      this.kind = this.reportKinds[0]
    }
  },
  data () {
    const dataAtual = new Date()
    const anoAtual = dataAtual.getFullYear()
    const anoInicial = 2014
    return {
      kind: 'month',
      startDate: moment().startOf('month').toDate(),
      endDate: moment().endOf('month').toDate(),
      month: moment().month() + 1,
      year: moment().year(),
      monthsOptions: monthsRespective.map((i, index) => ({id: index + 1, name: i})),
      yearsOptions: range(anoInicial, anoAtual).reverse().map(i => ({id: i}))
    }
  },
  methods: {
    updateState () {
      let info

      if (this.kind === 'period') {
        info = {
          startDate: this.startDate,
          endDate: this.endDate
        }
      } else {
        info = {month: this.month, year: this.year}
      }

      this.state = {...info, type: this.kind}
    },
    resetKind () {
      if (this.reportKinds) this.kind = this.reportKinds[0]
    }
  }
}
</script>

<style scoped lang="scss">
.month-and-year-wrapper {
  > div:first-child {
    display:grid;
    grid-template-columns: max-content max-content;
    grid-column-gap: 10px;
    margin-bottom: 20px;
  }
  > div:last-child {
    display:grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px
  }
}
</style>
